import * as t from 'ts-codec';
export var MailRoutes;
(function (MailRoutes) {
    MailRoutes["SEND_MAIL"] = "/api/v1/send-mail";
})(MailRoutes || (MailRoutes = {}));
export var MailTemplate;
(function (MailTemplate) {
    MailTemplate["PASSWORD_RESET"] = "password_reset";
    MailTemplate["VALIDATE_EMAIL"] = "validate_email";
})(MailTemplate || (MailTemplate = {}));
export const PasswordResetParams = t.object({
    template: t.literal(MailTemplate.PASSWORD_RESET),
    link: t.string
});
export const ValidateEmailParams = t.object({
    template: t.literal(MailTemplate.VALIDATE_EMAIL),
    link: t.string
});
export const MailTemplateParams = PasswordResetParams.or(ValidateEmailParams);
export const SendMailRequest = t.object({
    email: t.string,
    config: PasswordResetParams.or(ValidateEmailParams)
});
